import React, { useState, useEffect, useCallback } from "react";
import { SimpleGrid, IconButton, FormLabel, Button, Flex, Text, Box } from "@chakra-ui/react";
import Loading from "../../Component/Loading/loading";
import apiService from "../../Method/Advanced_Settings/Branch_Service";
import { ThemeProvider } from "@mui/material/styles";
import MUIDataTable from "mui-datatables";
import theme from "../../assets/Table/TableTheme";
import options from "../../assets/Table/TableOption_NoPrint";
import { EditIcon } from "@chakra-ui/icons";
import renderPermissionTile from "../../Component/Permission_Card/permission_card";
import InputText from "../../Component/Input/Input";
import CustomSwitch from "../../Component/Permission_Card/custom_switch";


import { t } from "i18next";

const columns = (handleEdit) => [
    {
        name: "_id",
        label: "ID",
        options: { filter: false, sort: false, display: false, viewColumns: false },
    },

    {
        name: "USER_NAME",
        label: t("USER_NAME"),
        options: { filter: false, sort: false },
    },
    {
        name: "PASSWORD",
        label: t("PASSWORD"),
        options: { filter: false, sort: false, display: false, viewColumns: false },
    },
    {
        name: "BRANCH_NAME",
        label: t("Branch_Name"),
        options: { filter: false, sort: false },
    },
    {
        name: "BRANCH",
        label: t("Branch_Code"),
        options: { filter: false, sort: false, display: false },
    },

    {
        name: "PERMISSION",
        label: "PERMISSION",
        options: { filter: false, sort: false, display: false, viewColumns: false },
    },
    {
        name: "",
        label: t("Edit"),
        options: {
            filter: false,
            sort: false,
            viewColumns: false,
            customBodyRender: (value, tableMeta) => (
                <IconButton
                    onClick={() => handleEdit(tableMeta)}
                    className="TableIcon"
                >
                    <EditIcon />
                </IconButton>
            ),
        },
    },
];

function App() {

    const [ID, setID] = useState("");
    const [showAllInvoices, setShowAllInvoices] = useState(false);
    const [Edit, isEdit] = useState(false);
    const [USER_NAME, setUSER_NAME] = useState("");
    const [Max_Date, setMax_Date] = useState(0);
    const [data, setData] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showPermissionBox, setShowPermissionBox] = useState(false);
    const [permissions, setPermissions] = useState({});

    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            const { success, data, error } = await apiService.get();
            if (success) {
                setData(data);
            } else {
                setError(error.message);
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const handleClear = () => {
        setUSER_NAME("");
        setError("");
        setID("");
        isEdit(false);
        setPermissions({});
        setShowPermissionBox(false);
    };

    const handleEdit = useCallback((data) => {
        const row = data.rowData;
        setID(row[0]);
        setUSER_NAME(row[1]);
        isEdit(true);

        setPermissions(
            row[5] && Object.keys(row[5]).length > 0
                ? row[5]
                : { PERMISSION_ALL: true }
        );
        setMax_Date(row[5]?.MAX_DATE || 0);

        setShowPermissionBox(true);
    }, []);

    const togglePermission = (key) => {
        setPermissions((prev) => {
            if (key === "PERMISSION_ALL") {
                const isEnablingAll = !prev.PERMISSION_ALL;
                return isEnablingAll
                    ? { PERMISSION_ALL: true }
                    : {
                        ...{},
                        PERMISSION_ALL: false,
                    };
            }

            return {
                ...prev,
                [key]: !prev[key],
                PERMISSION_ALL: false,
            };
        });
    };
    const isInvalidPermissions = () => {
        if (!permissions || Object.keys(permissions).length === 0) {
            return true;
        }

        const keys = Object.keys(permissions);
        return (
            keys.length === 1 &&
            keys[0] === "PERMISSION_ALL" &&
            permissions["PERMISSION_ALL"] === false
        );
    };
    const handleInsert = async (e) => {
        e.preventDefault();
        if (!Edit) return;

        if (isInvalidPermissions()) {
            setError("يرجى اختيار صلاحية على الأقل");
            return;
        }


        const payload = {
            SUB_ID: ID,
            MAIN_ACCOUNT_ID: localStorage.getItem("UserID"),

            PERMISSION: {
                ...permissions,
                MAX_DATE: parseInt(showAllInvoices ? -1 : Max_Date, 10),
            }
        };
        const { success, error } = await apiService.post(payload, "UPDATE_SUB_ACCOUNT_PERMISSIONS");

        if (success) {
            fetchData();
            handleClear();
        } else {
            setError(error.response?.data?.message || "حدث خطأ أثناء الحفظ");
        }
    };

    return (
        <ThemeProvider theme={theme}>
            {showPermissionBox && (
                <div style={{ width: "100%", }}
                    className={
                        Edit === true ? "Total_Header_Without_Bg" : ""
                    }
                >


                    <FormLabel className="Total_Header_Left  Total_Header_Right"  >
                        {USER_NAME}
                    </FormLabel>
                    <form onSubmit={handleInsert}>

                        <SimpleGrid
                            gap={2}
                            columns={{ base: 1, md: 2, lg: 3, "2xl": 3 }}

                        >
                            {renderPermissionTile(
                                "PERMISSION_ALL",
                                ["PERMISSION_ALL"],
                                permissions,
                                togglePermission
                            )}

                            <Box
                                className="Total_Header Permission_Header"
                                columns={{ base: 1 }}
                            >
                                <Box className="Total_Header_Left  Total_Header_Right">{t("Max_Date")}</Box>
                                <Flex
                                    justify="space-between"

                                    style={{ paddingInline: "25px" }}
                                    className="Permission_Content"
                                >
                                    <Text fontSize="md">{t("SHOW_ALL_INVOICE")}</Text>
                                    <CustomSwitch
                                        checked={showAllInvoices}
                                        onChange={() => {
                                            setShowAllInvoices(!showAllInvoices);
                                            setPermissions((prev) => ({
                                                ...prev,
                                                SHOW_ALL_INVOICE: !showAllInvoices,
                                            }));
                                        }}
                                    />
                                </Flex>

                                {!showAllInvoices && (
                                    <InputText
                                        type="number"
                                        required
                                        style={{ backgroundColor: "transparent" }}
                                        value={Max_Date}
                                        labels={t("Max_Date")}
                                        onChange={(value) => setMax_Date(value)}
                                    />
                                )}

                            </Box >

                        </SimpleGrid>

                        {permissions.PERMISSION_ALL !== true && (
                            <SimpleGrid
                                gap={2}
                                columns={{ base: 1, md: 2, lg: 3, "2xl": 3 }}
                                style={{ marginInline: "5px", marginTop: "15px" }}
                            >
                                <SimpleGrid gap={2} columns={1}>
                                    {renderPermissionTile(
                                        "Home",
                                        ["Home"],
                                        permissions,
                                        togglePermission
                                    )}
                                    {renderPermissionTile(
                                        "ITEMS_REPORTS",
                                        [
                                            "ITEMS_SALES_REPORT",
                                            "CATEGORY_SALES_REPORT"
                                        ],
                                        permissions,
                                        togglePermission
                                    )}


                                </SimpleGrid>
                                {renderPermissionTile(
                                    "SALES_REPORT_FOR",
                                    [
                                        "SALES_REPORT_HOURLY",
                                        "SALES_REPORT_DAY",
                                        "SALES_REPORT_DAY_WEEK",
                                        "SALES_REPORT_MONTH",
                                        "SALES_REPORT_YEARLY_QUARTERLY",
                                        "SALES_REPORT_YEAR"
                                    ],
                                    permissions,
                                    togglePermission
                                )}

                                {renderPermissionTile(
                                    "SALES_REPORT",
                                    [
                                        "INVOICE_SALES",
                                        "SALES_DELIVERY_RETURN",
                                        "IVC_SALES_REORT",
                                        "ERADAT_REPORT",
                                        "EXPENSES_REPORT",
                                        "INVOICE_TYPE_REPORT",
                                        "INVOICE_FINAL_SALES_REPORT",
                                        "APPLICATION_SALES",
                                        "CAPTIN_SALES",
                                    ],
                                    permissions,
                                    togglePermission
                                )}


                                {renderPermissionTile(
                                    "User_Report",
                                    [
                                        "ORDERS_USERS_REPORT",
                                        "INVOICE_USERS_REPORT"
                                    ],
                                    permissions,
                                    togglePermission
                                )}


                                {renderPermissionTile(
                                    "Monitor_Screen",
                                    ["Monitor_Screen_Report", "Deletion_And_Monitor_Report"],
                                    permissions,
                                    togglePermission
                                )}
                                {renderPermissionTile(
                                    "STORE_Report",
                                    ["ITEM_STORE_Report"],
                                    permissions,
                                    togglePermission
                                )}
                            </SimpleGrid>
                        )}

                        <Button type="submit" className="Permission-btn" mt={"15px"} >
                            {t("save")}
                        </Button>
                    </form>

                </div>
            )}

            {error && <p className="error-message">{error}</p>}
            {isLoading && <Loading />}

            {!isLoading && (
                <div style={{ width: "100%", overflowX: "auto", marginTop: "10px" }}
                    className={Edit === false ? "Total_Header_Without_Bg" : ""
                    }
                >
                    <MUIDataTable
                        title={""}
                        data={data}
                        columns={columns(handleEdit)}
                        options={options}
                    />
                </div>
            )}
        </ThemeProvider>
    );
}

export default App;
